import { rgba } from "config/variable";
import styled from "styled-components";
import { Button as antButton } from "antd";

export const CoverPageStyle = styled.div`
  height: 100%;
  padding: 24px;
  border-radius: 8px;
  background: ${(props) => props.theme.colordwhitedark};
  width: 100%;
`;

export const CoverPageHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  padding: 0 4px;
  
  h5 {
    font-size: 16px;
    margin: 0;
  }
`;

export const HeaderActions = styled.div`
  margin-left: auto;
  display: flex;
  gap: 10px;
  justify-content: flex-end;
`;

export const ActionWrapper = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
`;

export const ActionButton = styled.div`
  cursor: pointer;
`;

export const AssignedCount = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
  cursor: pointer;
  color: ${(props) => props.theme.primary};
  text-decoration: underline;
`;

export const EditButton = styled(antButton)`
  border: 1px solid ${(props) => props.theme.bordercolordlightblue};
  background-color: ${(props) => props.theme.bglightblue};
  padding: 0;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: none;
  display: flex;
  .anticon{
    margin: 0!important; 
  } &.delete-icon {
    color: ${(props) => props.theme.colordanger};
    &:hover {
      color: ${(props) => props.theme.colordanger};
    }
  }
  &.ant-dropdown-open {
    color: ${(props) => props.theme.textcolordarkblue};
  }
  &:disabled {
    color: ${(props) => rgba(props.theme.textcolordblack, 0.25)};
  }
`; 